import { ChangeDetectionStrategy, Component, computed, effect, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppSidebar } from '../sidebar/app-sidebar';
import { AppTopbar } from '../topbar/app-topbar';

@Component({
  selector: 'app-app-shell',
  imports: [RouterOutlet, AppTopbar, AppSidebar],
  templateUrl: './app-shell.html',
  styleUrl: './app-shell.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppShell {
  protected readonly isSidebarCollapsed = signal(this.loadSidebarState());
  protected readonly isSidebarOpen = signal(false);
  protected readonly isMobile = signal(typeof window !== 'undefined' ? window.innerWidth < 1024 : false);

  protected readonly showBackdrop = computed(() => this.isMobile() && this.isSidebarOpen());

  constructor() {
    effect(() => {
      if (!this.isMobile()) {
        this.isSidebarOpen.set(false);
      }
    });

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        const mobile = window.innerWidth < 1024;
        this.isMobile.set(mobile);
      });
    }
  }

  protected onToggleSidebar(): void {
    if (this.isMobile()) {
      this.isSidebarOpen.update((v) => !v);
    } else {
      this.isSidebarCollapsed.update((v) => !v);
      localStorage.setItem('iam_sidebar_collapsed', JSON.stringify(this.isSidebarCollapsed()));
    }
  }

  protected onBackdropClick(): void {
    this.isSidebarOpen.set(false);
  }

  private loadSidebarState(): boolean {
    if (typeof localStorage === 'undefined') return false;
    const saved = localStorage.getItem('iam_sidebar_collapsed');
    return saved ? JSON.parse(saved) : false;
  }
}
